var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0609 19.863C9.71392 20.086 9.36459 20.098 9.01288 19.8989C8.6612 19.6997 8.48535 19.3951 8.48535 18.9851V6.9067C8.48535 6.49666 8.6612 6.19207 9.01288 5.99293C9.36459 5.7938 9.71392 5.80577 10.0609 6.02885L19.5554 12.0861C19.874 12.2911 20.0333 12.5788 20.0333 12.9492C20.0333 13.3195 19.874 13.605 19.5554 13.8057L10.0609 19.863Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.74768c96.svg";
export { ForwardRef as ReactComponent };